import { Dispatch, SetStateAction } from "react";

import RenderImagesByBase64 from "@app/components/RenderNewUploadingImagesList/RenderImagesByBase64";
import SortableList, { SortableItem } from "react-easy-sort";

import { ImagesWrapper, StyledDrag } from './styled';

interface RenderNewUploadingImagesListProps<T> {
  sortable?: boolean;
  togetherImagesLength: number;
  newPreviewsList: string[] | [];
  setState: Dispatch<SetStateAction<T>>;
  handleDeleteImage?: (str: string) => void;

  // main image selection functionlity (OPTIONAL)
  posibilityToMainImage?: boolean;
  mainImageUrl?: string | null;
  onSortEnd?:(oldIndex: number, newIndex: number) => void;
  setMainImage?: (id: string) => void;
}

const RenderNewUploadingImagesList = <T, >({
  sortable,
  newPreviewsList,
  togetherImagesLength,
  setState,
  handleDeleteImage,

  // main image selection functionlity
  mainImageUrl,
  setMainImage,
  onSortEnd,
  posibilityToMainImage = false,
}: RenderNewUploadingImagesListProps<T>) => {
  if (!newPreviewsList.length) {
    return null
  }

  if (!sortable || !onSortEnd) {
    return (
      <ImagesWrapper className="images-wrapper">
        {
            newPreviewsList.map((src) => {
              return (
                <RenderImagesByBase64<T>
                  key={src}
                  src={src}
                  lengthOfImages={newPreviewsList.length}
                  mainImageUrl={mainImageUrl}
                  togetherImagesLength={togetherImagesLength}
                  posibilityToMainImage={posibilityToMainImage}
                  setState={setState}
                  setMainImage={setMainImage}
                  handleDeleteImage={handleDeleteImage}
                />
              )
            })
          }
      </ImagesWrapper>
    );
  }

  if (!onSortEnd) {
    return <div>Something went wrong</div>
  }

  return (
    <ImagesWrapper className="images-wrapper">
      <SortableList
        onSortEnd={onSortEnd}
        lockAxis="x"
        draggedItemClassName="dragged"
      >
        {
            newPreviewsList.map((src, index) => {
              return (
                <SortableItem
                  key={`${index + src}`}
                >
                  <StyledDrag>
                    <RenderImagesByBase64<T>
                      key={src}
                      src={src}
                      lengthOfImages={newPreviewsList.length}
                      mainImageUrl={mainImageUrl}
                      togetherImagesLength={togetherImagesLength}
                      posibilityToMainImage={posibilityToMainImage}
                      setState={setState}
                      setMainImage={setMainImage}
                      handleDeleteImage={handleDeleteImage}
                    />
                    <span className="take-ui" />
                  </StyledDrag>
                </SortableItem>
              )
            })
          }
      </SortableList>

    </ImagesWrapper>
  );
}

export default RenderNewUploadingImagesList;
